const fetchGraphQL = async ({
  query,
  url,
  variables,
  token
}) => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`
  };
  const body = JSON.stringify({
    query,
    variables
  });
  try {
    const response = await fetch(url, {
      method: "POST",
      headers,
      body
    });
    const responseData = await response.json();
    if (responseData.errors) {
      responseData.errors.forEach(
        (error) => console.error(error.message)
      );
      return responseData;
    }
    return responseData;
  } catch (error) {
    console.error(error);
    return error;
  }
};
export {
  fetchGraphQL
};
//# sourceMappingURL=fetchGraphQL.js.map
